<template>
  <div class="product-card" @click="$emit('click')">
    <div class="card-body mx-3 p-1 d-flex justify-content-between flex-column">
      <span class="text-secondary text-sm">Stock Code : {{ stock.PLU }}</span>
      <h6 class="product-description">
        {{ description }} <br>
        <span v-if="showQty">
          <span v-if="stock.QTY > 0" class="badge bg-info">Qty in Stock : {{ $utils.formatQTY(stock.QTY) }}</span>
          <span v-else-if="stockSetting.NonStock " class="badge bg-info">Service</span>
          <span v-else class="badge bg-danger">Not in Stock</span>
        </span><br>
        <span class="product-description2">{{ description2 }}</span>
      </h6>
      <h5 class="product-price">{{
          $utils.formatCurrency(itemPrice / debtorCurrency.Rate, 2, debtorCurrency.Symbol)
        }}</h5>
    </div>

  </div>
</template>

<script>
import {utils as $utils} from "@/utils/utils";
import {Storage} from "@/services/Storage"

export default {
  name: "Product",
  props: {
    stock: {
      type: Object,
      required: true
    }
  },
  mounted() {
    this.checkStockLevelSecurity();
    this.interval = setInterval(() => {
      this.checkStockLevelSecurity();
    }, 120000);
  },
  beforeDestroy() {
    clearInterval(this.interval);
  },
  methods : {
    async checkStockLevelSecurity() {
      let securities = await Storage.getAllSecurities();
      let user = this.$store.getters.getCurrentUser;
      let userSecurity = securities.find(security => security.GroupName === user.Type);
      if (!userSecurity) return false;
      this.showQty =  !userSecurity.hideQuantity;
    },
  },
  computed: {
    description() {
      return this.$utils.toPascalCase(this.stock.Description);
    },

    description2() {
      return $utils.toPascalCase(this.stock.Description2)
    },
    customer() {
      return this.$store.getters.getCustomer;
    },
    debtorCurrency() {
      return this.$store.getters.getDebtorCurrency;
    },
    itemPrice() {
      return this.$store.getters.getDebtorPrice({
        id: this.customer,
        item: this.stock
      });
    }
  },
  data() {
    return {
      windowWidth: window.innerWidth,
      textLength: 50,
      showQty: true,
      stockSetting: {
        NonStock: false
      },
    }
  },
  watch: {
    windowWidth(nh, oh) {
      if (nh < 400) {
        this.textLength = 25
      }
    },
    'stock.PLU'(nv, ov) {
      return this.$store.dispatch('getStockSetting', nv).then(stockSettings => {
        if (stockSettings) {
          this.stockSetting = stockSettings;
        }
      })
    }
  }
}
</script>

<style lang="scss" scoped>
img {
  width: 80px;
}

h4, h5, h6 {
  margin: 0;
}

.example-card-img-responsive {
  width: 80px;
  height: 65px;
  margin: 10px;
  opacity: 0.8;
}


.product-card {
  height: fit-content;
  transition: 200ms ease-in-out;
  overflow: hidden;
  width: 100%;
  word-wrap: break-word;
  background-color: #fff;
  background-clip: border-box;
  border: 1px solid rgba(0, 0, 0, 0.125);
  border-radius: 0.25rem;
  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;

  .product-description {
    font-weight: 600;
    color: #303030;
  }

  .product-description2 {
    font-weight: 400;
    color: #303030;
  }

  .product-price {
    font-weight: 700;
    color: #322f2f;
  }

  &:hover, &:focus {
    background: #9ccc65;
    color: white;
    transform: scale(1.03);

    .product-description {
      color: white;
    }

    .product-price {
      color: white;
    }
  }
}

img {
  height: 60px;
  width: 60px;
  opacity: 0.7;
  object-fit: contain;
  border-radius: 10px;
}

.text-sm {
  font-size: 12px !important;
}

</style>
